/**
 * The landing puts every band on one 1240px measure with a fluid gutter, so the
 * class string lives here rather than being retyped (and drifting) in ten
 * section components.
 */
export const SITE_CONTAINER = 'mx-auto w-full max-w-[1240px] px-[clamp(20px,5vw,72px)]';
